import React, {Component} from 'react';
import { withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

class HeaderLeft extends Component {
    render() {
     
        return (
            <div className="menu menu--top-left">
                <ul>
                    {/*
                    <li>
                        <div className="badge badge--empty">
                           
                        </div>
                    </li>
                    <li>
                        <div className="badge badge--messages">
                            <img src={logo} />
                        </div>
                    </li>
                    <li>
                        <div className="badge badge--messages">
                            <img src={logo} />
                        </div>
                    </li>*/}
                </ul>
                
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.UserReducer,
        clientPath: state.ClientPathReducer.clientPath
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderLeft));


// WEBPACK FOOTER //
// ./src/components/Layout/Header/HeaderLeft/index.js